import Vue from 'vue';
import MenuComponent from '@app/modules/RF/CMS/Menu.vue';
export default Vue.extend({
    data: function () {
        return {
            company: 'Wintsch & Partner GmbH',
            company2: 'Architektur und Baumanagement',
            street: 'Aathalstrasse 84a',
            city: '8610 Uster',
            name: this.$settings('owner.name'),
            address: this.$settings('owner.address'),
            phone: this.$settings('owner.phone'),
            email: this.$settings('owner.email')
        };
    },
    components: {
        MenuComponent: MenuComponent
    }
});
